import { Component, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-picker',
  templateUrl: './picker.component.html',

})

export class PickerComponent {

  @Input() data: any;
  @Input() type: string;
  @Input() placeholder: string;
  @Input() filterList: any;
  //@Input() fastFilter: string;
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();


 
  public ngOnInit(): any {
  }

  //ngOnChanges(changes: SimpleChanges): void {
  //  if (changes['fastFilter']) {
  //    const previous = changes['fastFilter'].previousValue;
  //    const current = changes['fastFilter'].currentValue;
  //    console.log(`fastFilter changed from "${previous}" to "${current}"`);
  //    this.filterQuery = current;

  //    this.dspList = !current? false  : true;

  //    // You can trigger filtering logic here
  //  }
  //}



  public outputSelected(itm: any) {
    this.selected.emit(itm);
    this.dspList = false
    this.filterQuery = ""

  }

   // myDataShops: any;
    filterQuery: string = "";
    dspList = false

    showData(event: any) {
      var inputVal = event.target.value;
      this.dspList = (inputVal.length > 1 ? true : false);
    }



}


